module.exports = __webpack_public_path__ + "assets/17862684a48024cbcd4b4dd99eb2cc95.mp3";